import { Outlet, Navigate } from 'react-router-dom'
import  Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux';

const PrivateRoutes = () => {
    const navigate = useNavigate();
    const { isLoggedIn } = useSelector((state) => state.auth);


    useEffect(() => {
        if (!isLoggedIn) {
            navigate("/");
        }
        console.log('blah');
    }, [isLoggedIn]);

    return (
        isLoggedIn ? <Outlet /> : <Navigate to="/" />
    )
}

export default PrivateRoutes